/* eslint-disable  react/prop-types */

import React from 'react';

const BankIcon = ({ width = 32, height = 32, style = {} }) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
  >
    <path
      d="M13.641 19.942c-.088-.086-.28-.433 0-.92.281-.486.694-.373.8-.295.299.2.835.573 1.494.573.421 0 .73-.26.73-.625 0-.434-.387-.72-1.09-1.05-1.011-.495-2.04-1.05-2.04-2.3 0-1.034.818-2.075 2.435-2.075 1.098 0 1.942.555 2.258.781.123.07.044.556-.15.816-.192.26-.58.512-.79.39-.237-.164-.861-.563-1.424-.563-.439 0-.641.269-.641.572 0 .348.413.617 1.151.973.932.451 2.127.954 2.127 2.37 0 1.076-.94 2.152-2.487 2.152-1.371.009-2.127-.555-2.373-.799Z"
      fill="#00AED9"
    />
    <rect
      x="15.377"
      y="12"
      width="1.25"
      height="2.5"
      rx=".625"
      fill="#00AED9"
    />
    <rect
      x="15.377"
      y="19.5"
      width="1.25"
      height="2.5"
      rx=".625"
      fill="#00AED9"
    />
    <rect
      x="3"
      y="27"
      width="26"
      height="3"
      rx="1"
      stroke="#00619E"
      strokeWidth="2"
    />
    <rect
      x="5"
      y="24"
      width="22"
      height="3"
      rx="1"
      stroke="#00619E"
      strokeWidth="2"
    />
    <path stroke="#00619E" strokeWidth="2" d="M10 13v11H7V13zm15 0v11h-3V13z" />
    <path
      d="M17.06 2.842 28.513 10H3.487L14.94 2.842a2 2 0 0 1 2.12 0Z"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export default BankIcon;
